import axios from "axios";


export default {
  /**
   * 이마티콘 토큰 발급 함수
   * @param {context}
   * @param {String} encryptedMberNo 암호화된 mberNo
   */
  GET_EMARTICON_TOKEN({commit}, encryptedMberNo) {
      try {
        const params = {
          method: 'GET',
          url: '/api/emarticon/v1.0.0/create-token',
          params:{
            mberNo : encryptedMberNo
          }
        }
        return axios.request(params);
      } catch (error) {
        window.location.replace(process.env.VUE_APP_EMARTICON_SITE_DOMAIN + '/error');
      }
  }
};

